import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function Apple({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (
<div className="wrapper">
	<div className="inner-wrapper">
		<Helmet>
		    <meta charSet="utf-8" />
		    <title>Maria Chimishkyan — {ProjectModel.Apple.title}</title>
		</Helmet>

	    <Container fluid className="page-pad">
			<Row>
				<Col sm={3}>
					<div className="description-sticky">
					  <ProjectDescription projectModel={ProjectModel.Apple}/>
					</div>
				</Col>
				<Col sm={6}>
					<img src="img/project-page/apple/apple-MariaChimishkyan-1.jpg" alt="Apple — Maria Chimishkyan 1" style={{ width: '100%' }}/>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-2.gif" alt="Apple — Maria Chimishkyan 2" style={{ width: '100%' }}/>
							<div className="project-caption">Book</div>
						</div>
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-3.gif" alt="Apple — Maria Chimishkyan 3" style={{ width: '100%' }}/>
							<div className="project-caption">Candle</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-4.gif" alt="Apple — Maria Chimishkyan 4" style={{ width: '100%' }}/>
							<div className="project-caption">Headphones</div>
						</div>
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-5.gif" alt="Apple — Maria Chimishkyan 5" style={{ width: '100%' }}/>
							<div className="project-caption">Hourglass</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-6.gif" alt="Apple — Maria Chimishkyan 6" style={{ width: '100%' }}/>
							<div className="project-caption">Key</div>
						</div>
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-7.gif" alt="Apple — Maria Chimishkyan 7" style={{ width: '100%' }}/>
							<div className="project-caption">Ladder</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-8.gif" alt="Apple — Maria Chimishkyan 8" style={{ width: '100%' }}/>
							<div className="project-caption">Lightbulb</div>
						</div>
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-9.gif" alt="Apple — Maria Chimishkyan 9" style={{ width: '100%' }}/>
							<div className="project-caption">Link</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-10.gif" alt="Apple — Maria Chimishkyan 10" style={{ width: '100%' }}/>
							<div className="project-caption">Magnifying Glass</div>
						</div>
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-11.gif" alt="Apple — Maria Chimishkyan 11" style={{ width: '100%' }}/>
							<div className="project-caption">Mic</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-12.gif" alt="Apple — Maria Chimishkyan 12" style={{ width: '100%' }}/>
							<div className="project-caption">Mug</div>
						</div>
						<div>
							<img src="img/project-page/apple/apple-MariaChimishkyan-13.gif" alt="Apple — Maria Chimishkyan 13" style={{ width: '100%' }}/>
							<div className="project-caption">Puzzle Pieces</div>
						</div>
					</div>
					</div>
				</Col>
			</Row>
		</Container>
	</div>
	<ProjectIndex/>
</div>

  )
}

export default connect()(Apple);
